import { render, staticRenderFns } from "./DecoratedLink.vue?vue&type=template&id=45228536&scoped=true&"
import script from "./DecoratedLink.vue?vue&type=script&lang=js&"
export * from "./DecoratedLink.vue?vue&type=script&lang=js&"
import style0 from "./DecoratedLink.vue?vue&type=style&index=0&id=45228536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45228536",
  null
  
)

export default component.exports